import { GLOBAL_COLORS_HOLSTER, applyCamoMarkup } from '../config/globalSettings';

// ==========================================
// 1. DEFINE MOUNT GROUPS (The "Buckets")
// ==========================================
export const MOUNT_GROUPS = {
    // Standard mounts for AR, MP5, AUG, etc.
    STANDARD_MOUNTS: [
        "injection_clip_15", "injection_clip_175", "tek_lok","tek_lok_drop",
        "monoblock_logo", "dcc_TOPOlogo","dcc_tigerstripe", "dcc_FDElogo", "dcc_nologo"
    ],
    // Specific mounts restricted to AK / VEPR mags
    AK_MOUNTS: [
        "injection_clip_15", "injection_clip_175", "tek_lok", "tek_lok_drop",
        "monoblock_logo", "dcc_TOPOlogo", "dcc_tigerstripe", "dcc_FDElogo", "dcc_nologo"
    ]
};

export const rifleMagData = {
  // --- MAG MODELS ---
  mags: [
    // --- QUICK SHIP (5-7 DAYS) ---
    { 
      id: "ar_style", 
      name: "AR 15 Magazine", 
      qs_mag: true,
      supported_mounts: MOUNT_GROUPS.STANDARD_MOUNTS,
      details: `
        <strong>AR Style Magazine Features:</strong><br/>
        <ul>
          <li><strong>Universal Design:</strong> Fits a wide range of AR-style rifle magazines.</li>
          <li><strong>Durable Construction:</strong> Made from high-quality KYDEX® Thermoplastics for lasting performance.</li>
          <li><strong>Mil-Spec Info:</strong> ANR Universal Mag Carrier 1.75 MULTICAM (NSN#: 1005-01-694-7359).</li>
        </ul>
      `
    },
    { 
      id: "hk_417", 
      name: "HK 417", 
      qs_mag: true,
      supported_mounts: MOUNT_GROUPS.STANDARD_MOUNTS,
      details: `
        <strong>HK 417 Features:</strong><br/>
        Dominate the field with the ANR Design HK417 KYDEX® Thermoplastics Rifle Mag Carrier. Engineered for superior retention, durability, and lightning-fast reloads, this mag carrier is the perfect companion for your HK417 rifle.
      `
    },
    { 
      id: "sr25", 
      name: "SR25 / AR10 (Metal)", 
      qs_mag: true,
      supported_mounts: MOUNT_GROUPS.STANDARD_MOUNTS,
      details: `
        <strong>SR25/AR10 Universal Features:</strong><br/>
        ANR DESIGN CNC cut, vacuumed formed SR25/AR10 Universal Rifle Mag Carrier to comfortably carry your backup magazines. Our single KYDEX® Thermoplastics rifle mag carriers provide you with increased durability and perfect retention needed for all applications.
      `
    },
    { 
      id: "pmag_sr25", 
      name: "PMAG SR25 / AR10", 
      qs_mag: true,
      supported_mounts: MOUNT_GROUPS.STANDARD_MOUNTS,
      details: "<strong>PMAG SR25 Features:</strong><br/>Optimized for Polymer SR25/AR10 PMAGs. Ensures smooth draw and secure retention."
    },
    { 
      id: "precision_rifle", 
      name: "AI 308 Precision Rifle Mag Carrier", 
      qs_mag: true,
      supported_mounts: MOUNT_GROUPS.STANDARD_MOUNTS,
      details: `
        <strong>Precision Rifle Features:</strong><br/>
        ANR Design offers minimalistic CNC cut, vacuum formed AI Precision Rifle Magazine Carriers. Fits AICS, AW/AX (10 and 5 round mags).<br/><br/>
        Also fits MDT 308, Ruger AICS 308, & Magpul AICS 308 (some tightness or looseness may be experienced with these magazine models, please email for suggestions if there are issues).
      `
    },
    
    // --- STANDARD (3-5 WEEKS) ---
    { id: "ak47_pmag", name: "AK 47 PMAG", supported_mounts: MOUNT_GROUPS.AK_MOUNTS },
    { id: "ak47_romanian", name: "AK 47 Romanian Stamped", supported_mounts: MOUNT_GROUPS.AK_MOUNTS },
    { id: "ak47_tapco", name: "AK 47 Tapco Intrifuse", supported_mounts: MOUNT_GROUPS.AK_MOUNTS },
    { id: "ak74", name: "AK 74 5.45x39", supported_mounts: MOUNT_GROUPS.AK_MOUNTS },
    { id: "kr9", name: "KR-9", supported_mounts: MOUNT_GROUPS.STANDARD_MOUNTS },
    { id: "mp5", name: "MP5 (9mm)", supported_mounts: MOUNT_GROUPS.STANDARD_MOUNTS },
    { id: "steyr_aug", name: "Steyr AUG", supported_mounts: MOUNT_GROUPS.STANDARD_MOUNTS },
    { id: "vepr", name: "VEPR 7.62x54R", supported_mounts: MOUNT_GROUPS.AK_MOUNTS }
  ],

  // --- CONFIGURATION 1: CARRY SIDE ---
  sides: [
    { id: "left", name: "Left Side Carry" },
    { id: "right", name: "Right Side Carry" }
  ],

  // --- CONFIGURATION 2: GRIP TYPE ---
  grips: [
    { id: "index", name: "Index Grip (Bullets Forward)", description: "Mag draws with index finger along the spine." },
    { id: "coke_can", name: "Coke Can Grip (Bullets Rear)", description: "Mag draws with a full palm grip (Beer Can style)." }
  ],

  // --- COLORS (Mapped for $20 markup) ---
  colors: applyCamoMarkup(GLOBAL_COLORS_HOLSTER, 20),

 // --- MOUNTS ---
  mounts: [
    { 
      id: "injection_clip_15", 
      name: "1.5\" Injection Molded Clip", 
      price: 0, 
      img_layer_mount: "/images/mounts/rifle_mag/injection_clip_15_front.png", 
      img_layer_mount_back: "/images/mounts/rifle_mag/injection_clip_15_back.png",
      description: "Standard plastic fold-over clip for 1.5\" belts."
    },
    { 
      id: "injection_clip_175", 
      name: "1.75\" Injection Molded Clip", 
      price: 0, 
      img_layer_mount: "/images/mounts/rifle_mag/injection_clip_175_front.png", 
      img_layer_mount_back: "/images/mounts/rifle_mag/injection_clip_175_back.png",
      description: "Standard plastic fold-over clip for 1.75\" belts."
    },
    { 
      id: "tek_lok", 
      name: "Blade-Tech Tek-Lok", 
      price: 12.00, 
      img_layer_mount: "/images/mounts/rifle_mag/teklok_front.png", 
      img_layer_mount_back: "/images/mounts/rifle_mag/teklok_back.png",
      description: "Secure, adjustable belt attachment system."
    },
    
    { 
      id: "tek_lok_drop", 
      name: "Blade-Tech Tek-Lok w/ Ridgeline Drop", 
      price: 30.99, 
      img_layer_mount: "/images/mounts/rifle_mag/teklok_drop_front.png", 
      img_layer_mount_back: "/images/mounts/rifle_mag/teklok_drop_back.png",
      description: "Lowers the carrier for clearance with plate carriers or chest rigs."
    },

    { 
      id: "monoblock_logo", 
      name: "1.5\" DCC Monoblock w/ ANR Logo", 
      price: 7.25, 
      img_layer_mount: "/images/mounts/rifle_mag/monoblock_front.png", 
      img_layer_mount_back: "/images/mounts/rifle_mag/monoblock_back.png",
      description: "Heavy duty steel clip with laser engraved ANR logo."
    },
    { 
      id: "dcc_TOPOlogo", 
      name: "1.5\" DCC TOPO", 
      price: 8.25, 
      img_layer_mount: "/images/mounts/rifle_mag/dcc_topo_front.png", 
      img_layer_mount_back: "/images/mounts/rifle_mag/dcc_topo_back.png",
      description: "Heat treated steel alloy with TOPO design."
    },
    { 
      id: "dcc_tigerstripe", 
      name: "1.5\" DCC Tiger Stripe", 
      price: 8.25, 
      img_layer_mount: "/images/mounts/rifle_mag/dcctigerstripe_front.png", 
      img_layer_mount_back: "/anr-builder/images/mounts/rifle_mag/dcctigerstripe_back.png",
      description: "Heat treated steel alloy with Tiger Stripe design."
    },
    { 
      id: "dcc_FDElogo", 
      name: "1.5\" DCC FDE", 
      price: 7.25, 
      img_layer_mount: "/images/mounts/rifle_mag/dcc_fde_front.png", 
      img_layer_mount_back: "/images/mounts/rifle_mag/dcc_fde_back.png",
      description: "Heat treated steel alloy in FDE."
    },
    { 
      id: "dcc_nologo", 
      name: "1.5\" DCC No Logo", 
      price: 6.25, 
      img_layer_mount: "/images/mounts/rifle_mag/dcc_nologo_front.png", 
      img_layer_mount_back: "/images/mounts/rifle_mag/dcc_nologo_back.png",
      description: "Heat treated steel alloy. High clamping force. Clean, no logo finish."
    }
  ],

// --- HANGERS ---
  hangers: [
    { 
      id: "no", 
      name: "No Thanks", 
      price: 0 
    },
    { 
      id: "yes", 
      name: "Yes - Deep Concealment Hanger", 
      price: 18.00,
      img_layer_hanger_front: "/images/hangers/rifle_mag/deep_concealment_hanger_front.png",
      img_layer_hanger_back: "/images/hangers/rifle_mag/deep_concealment_hanger_back.png",
      description: "Our Deep Concealment Rifle Magazine Hanger was designed for the ultimate low visibility option for carrying 556/300 type magazines inside the waistband. Utilizing CURV™ as the light weight and robust method of suspending our KYDEX® Universal AR-15 magazine carrier deep in the waistband to comfortably carry and conceal 30 round and 20 round magazines. The hanger has multiple mounting heights to adjust the depth of your preferred magazine type and size."
    }
  ],


  // --- EXTRAS ---
  breakthrough: [ 
    { id: "no", name: "No Thanks", price: 0 }, 
    { id: "solvent", name: "Breakthrough Military Grade Solvent", price: 8.95 },
    { id: "oil", name: "Breakthrough Battle Born High Purity Oil", price: 8.95 },
    { id: "lubricant", name: "Breakthrough Battle Born Pro Lubricant", price: 12.95 },
    { id: "bundle", name: "Breakthrough Clean Bundle", price: 16.00 }
  ],

  warranties: [ 
    { id: "30_day", name: "30 Day Mfg Warranty", price: 0 }, 
    { id: "lifetime", name: "Lifetime Warranty", price: 12.99 } 
  ]
};